<template>
    <div>
        <h1 style="text-align: center;" class="mt-7">{{propsdata[0]['translation']['account-tabs-title']}}</h1>
        <br>
        <div class="container nav-tabs border-0" style="overflow: scroll;display: flex;">
            <router-link to="/dashboard/account" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['account-tabs-button-account']}}</router-link>
            <router-link to="/dashboard/api" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['account-tabs-button-api-key']}}</router-link>
            <router-link to="/dashboard/google-analytics" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['account-tabs-button-ga']}}</router-link>
            <router-link to="/dashboard/team-members" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['account-tabs-button-team-members']}}</router-link>
            <router-link to="/dashboard/billing" exact-active-class="activetabs" class="nav-item nav-link rounded-bottom-0">{{propsdata[0]['translation']['account-tabs-button-billing']}}</router-link>
        </div>
    </div>
</template>

<style scoped>
    .activetabs{
    background: #ffffff!important;
    border-color: #dde1ed!important;
    color: #11ab7c!important;
    }
</style>

<script>
    export default {
        props:['propsdata'],
    };
</script>



// WEBPACK FOOTER //
// src/account-tabs.vue